import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import SubmitToAuditorModal from "./SubmitToAuditorModal";
import AuditDetailsModal from "./AuditDetailsModal";
import * as api from "../../../../backend/request";
import {
  hasUserAccess,
  getUserDetails,
  getUserRole,
} from "../../../../backend/auth";
import AuditorVendorActivityModal from "../../Auditor/AuditorVendorActivityModal";
import EditActivityModal from "./EditVendorActivityModal";
import { toast } from "react-toastify";
import PageLoader from "../../../shared/PageLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faEllipsisV, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {
  AUDIT_STATUS as VENDOR_AUDIT_STATUS,
  AUDIT_STATUS_LABELS,
  canVendorSaveActivity,
  canAuditorEditTodo,
  canSubmitToAuditor,
  canFinalizePreliminaryAudit,
  canPublishFinalAudit,
  isFirstTimePublishCheck,
  getNewAuditStatusAfterSubmit,
  USER_ROLE,
  AUDIT_STATUS_COLOR_CODES
} from "../../../../utils/auditStateMachine";
import BulkUploadModal from "./BulkuploadModal";
import { Link, usePath, useHistory, usePathParams, navigate } from "raviger";
import PublishModal from "../../Auditor/PublishModal";
import Table, {
  CellTmpl,
  DEFAULT_PAYLOAD,
  TitleTmpl,
  reactFormatter,
} from "../../../common/Table";
import {
  ACTIONS,
  ACTIVITY_STATUS,
  AUDIT_STATUS,
  FILTERS,
  MONTHS_ENUM,
  STATUS_MAPPING,
  TOOLTIP_DELAY,
} from "../../../common/Constants";
import {
  useExportVendorTodos,
  useGetAllVendorActivities,
} from "../../../../backend/query";
import Icon from "../../../common/Icon";
import {
  download,
  downloadFileContent,
  preventDefault,
} from "../../../../utils/common";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import AlertModal from "../../../common/AlertModal";
import {
  ACTIVITY_TYPE,
  ACTIVITY_TYPE_ICONS,
  ERROR_MESSAGES,
} from "../../../../utils/constants";
import {
  getAuditReportFileName,
  useAuditReportForVendor,
} from "../../../../backend/exports";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import styles from "./TaskManagement.module.css";
import TableActions, { ActionButton } from "../../../common/TableActions";
import SendEmailModal from "../../Auditor/SendEmailModal";
import VendorBulkUploadModal from "./VendorToDoBulkModal";
import { AxiosError } from "axios";
import { Button } from "react-bootstrap";
import PublishAgainModal from "../../Auditor/PublishAgainModal";
import AuditLocationFilters from "../../../common/AuditLocationFilters";
import ConfirmModal from "../../../common/ConfirmModal";
import { IconButton } from "@mui/material";
import { IoMdInformationCircleOutline } from "react-icons/io";

const include = ['company', 'associate_company', 'location', 'vendor_category', 'vendor_registration', 'preliminary_report', 'final_report'];
const includes = ['company', 'associate_company', 'location', 'vendor_category', 'vendor_registration', 'preliminary_report', 'final_report'];

const STATUS_BTNS = [
  {
    name: ACTIVITY_STATUS.ACTIVITY_SAVED,
    label: STATUS_MAPPING[ACTIVITY_STATUS.ACTIVITY_SAVED],
    style: "secondary",
  },
  {
    name: ACTIVITY_STATUS.PENDING,
    label: STATUS_MAPPING[ACTIVITY_STATUS.PENDING],
    style: "warning",
  },
  {
    name: ACTIVITY_STATUS.OVERDUE,
    label: STATUS_MAPPING[ACTIVITY_STATUS.OVERDUE],
    style: "danger",
  },
  {
    name: ACTIVITY_STATUS.SUBMITTED,
    label: STATUS_MAPPING[ACTIVITY_STATUS.SUBMITTED],
    style: "danger",
  },
  {
    name: ACTIVITY_STATUS.REJECTED,
    label: STATUS_MAPPING[ACTIVITY_STATUS.REJECTED],
    style: "danger",
  },
  {
    name: ACTIVITY_STATUS.AUDITED,
    label: STATUS_MAPPING[ACTIVITY_STATUS.AUDITED],
    style: "danger",
  },
];

const SortFields: any = {
  "act.name": "actn_ame",
  "rule.name": "rule_name",
  "activity.name": "activity_name",
  "activity.type": "activity_activity_type",
  "associate_company.name": "associate_company_name",
  "location.name": "location_name",
};

function getAdvanceSearch(state: any) {
  const filters: any = {};
  if ((state || {}).fromDate) {
    filters.from_date_eq = dayjs(state.fromDate).startOf("D").toISOString();
    filters.to_date_eq = dayjs(state.toDate).endOf("D").toISOString();
  }

  if ((state || {}).auditType) {
    filters.audit_type_eq = state.auditType;
  }
  return filters.length > 0 ? filters : undefined;
}

function VendorLocationActivitiesManagement({ auditId }: any) {
  const { state }: any = useHistory();
  const [action, setAction] = useState(ACTIONS.NONE);
  const [statusBtns] = useState(STATUS_BTNS);
  const [submitting, setSubmitting] = useState(false);
  const [checkedStatuses, setCheckedStatuses] = useState<any>(
    (state || {}).status ? { [state.status]: true } : {}
  );
  const [activity, setActivity] = useState<any>(null);
  const [bulkUpload, setBulkUpload] = useState(false);
  const [vendorUpload, setVendorUpload] = useState<boolean>(false);
  const [submitToAuditor, setSubmitToAuditor] = useState(false);
  const [showAuditDetails, setShowAuditDetails] = useState(false);
  const path: any = usePath();
  const [fromDashboard] = useState(path.includes("/dashboard/activities"));
  const [data, setData] = useState<any>();
  const [params, setParams] = useState<any>();
  const [advaceSearchFilters, setAdvanceSearchFilters] = useState(
    getAdvanceSearch(state)
  );
  const afRef: any = useRef();
  afRef.current = advaceSearchFilters;
  const [statusFilters, setStatusFilters] = useState<any>();
  const sfRef = useRef();
  sfRef.current = statusFilters;
  const [payload, setPayload] = useState<any>();
  const payloadRef = useRef();
  payloadRef.current = payload;
  const { activities, total, isFetching, refetch } = useGetAllVendorActivities(
    payload,
    Boolean(hasFilters(null, "vendor_location_audit_id_eq"))
  );
  const [publish, setPublish] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [alertMessage, setAlertMessage] = useState<any>(null);
  const [isFirstTimePublish, setIsFirstTimePublish] = useState<boolean>(true);
  const [sendEmailOnPublishAgain, setSendEmailOnPublishAgain] = useState<boolean>(false);
  const [publishAgain, setPublishAgain] = useState<boolean>(false);
  const [currentAudit, setCurrentAudit] = useState<any>({});
  const [enableEditAlert, setEnableEditAlert] = useState<boolean>(false);
  const [selectedReportForDownload, setSelectedReportForDownload] = useState<any>(null);
  const [userRole] = useState(getUserRole());
  const { auditReportVendor, exporting } = useAuditReportForVendor(
    (response: any) => {
      if (response) {
        const filename = selectedReportForDownload && selectedReportForDownload.name ? selectedReportForDownload.name.charAt(0).toUpperCase() + selectedReportForDownload.name.slice(1) : 'audit_report';
        downloadFileContent({
          name: filename,
          type: response.headers["content-type"],
          content: response.data,
        });
      }
    },
    (error: any) => {
      console.log(error)
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  );
  const { exportTodos, exporting: exportingTodos } = useExportVendorTodos(
    (response: any) => {
      downloadFileContent({
        name: "Audit Vendor Activities.xlsx",
        type: response.headers["content-type"],
        content: response.data,
      });
    },
    () => {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  );

  useEffect(() => {
    if (auditId) {
      refetchAudit();
    } else {
      navigate('/vendor-audits');
    }
  }, [auditId]);

  useEffect(() => {
    if (auditId) {
      // Initialize filters with vendor_location_audit_id_eq
      setAdvanceSearchFilters({
        vendor_location_audit_id_eq: auditId
      });
    }
  }, [auditId]);

  function publishActivity(e: any) {
    preventDefault(e);
    if(![VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_EDITING, VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status)) {
      toast.error("You cannot publish activities at this stage.");
    } else {
      setSubmitting(true);
      const _payload = {
          filters: {
              vendor_location_audit_id_eq: auditId
          }
      };
      api
        .get("/api/v1/todo_vendors", _payload)
        .then((response) => {
          if (response && response.data) {
            const _rows = (response.data || {data: {}}).items || [];
            const auditableRows = _rows.filter((x: any) =>
              [ACTIVITY_TYPE.AUDIT, ACTIVITY_TYPE.PHYSICAL_AUDIT].includes(
                x.auditted
              )
            );
            const submittedRows = auditableRows.filter((x: any) =>
              [
                ACTIVITY_STATUS.SUBMITTED,
                ACTIVITY_STATUS.PENDING,
                ACTIVITY_STATUS.OVERDUE,
                ACTIVITY_STATUS.ACTIVITY_SAVED,
              ].includes(x.status)
            );
            const _published = auditableRows.filter((x: any) => x.published) || [];
            if (_published.length && ![VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status) && (_published.length == _rows.length)) {
              setAlertMessage(
                "All the activities are published for the selected month and year. See Audit report for more details."
              );
            } else if (_rows.length === 0) {
              setAlertMessage(
                `<p class="my-3">There are no activties available for the selected month and year.</p>`
              );
            } else if (submittedRows.length > 0) {
              setAlertMessage(
                `<p class="my-3">There are ${submittedRows.length} activities not reviewed for the selected month and year.</p>
                            <p>Review them before publishing.</p>`
              );
            } else if (_rows.length > 0) {
              setSelectedRows(_rows);
              if(isFirstTimePublish){
                setPublish(true);
              } else {
                setPublishAgain(true);
              }
            }
          }
        })
        .finally(() => setSubmitting(false));
    }
  }

  async function onPublish(e: any, { recommendations, observations, vendor_nature_of_work, employee_head_count, audit_start_date, audit_end_date }: any, sendEmail: boolean = true, onlyUnpublished: boolean = false, treatAsFinalAudit: boolean = false) {
    preventDefault(e);
    setSubmitting(true);

    const publishPayload = {
      recommendations: recommendations == "<div><br></div>" ? "" : recommendations,
      observations: observations == "<div><br></div>" ? "" : observations,
      send_email: sendEmail,
      only_unpublished: onlyUnpublished,
      vendor_nature_of_work: vendor_nature_of_work || "",
      employee_head_count: employee_head_count || "",
      audit_date: audit_start_date ? dayjs(audit_start_date).startOf('D').local().format() : null,
      audit_end_date: audit_end_date ? dayjs(audit_end_date).startOf('D').local().format() : null
    }

    if(treatAsFinalAudit || [VENDOR_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_EDITING, VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status)){
      publishFinalAudit(e, publishPayload);
    } else {
      finalizePreliminaryAudit(e, publishPayload);
    }
  }

  function publishAndTriggerEmail() {
    setSendEmailOnPublishAgain(true);
    publishActivity(null)
  }

  function publishWithoutTriggeringEmail() {
    setSendEmailOnPublishAgain(false);
    publishActivity(null)
  }

  function onPublishAgain(e: any, { recommendations, observations, vendor_nature_of_work, employee_head_count, audit_start_date, audit_end_date }: any, treatAsFinalAudit: boolean = false) {
    preventDefault(e);
    onPublish(null, { recommendations, observations, vendor_nature_of_work, employee_head_count, audit_start_date, audit_end_date }, sendEmailOnPublishAgain, true);
  }

  async function finalizePreliminaryAudit(e: any, publishPayload: any) {
    preventDefault(e);
    setSubmitting(true);

    try {
      const endpoint = `/api/v1/vendor_location_audits/${currentAudit.id}/${VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_FINALIZED}`;

      let response: any = await api.put(endpoint, publishPayload);
      if(response instanceof AxiosError){
        const errorMessage = "Failed to finalize preliminary audit. Please try again.";
        toast.error(errorMessage);
        setSubmitting(false);
        return;
      }
      setTimeout(async() => {
        const successMessage = "Preliminary audit finalized successfully. Generating report...";
        toast.success(successMessage);
        await refetchAudit();
        refetch();
        setPublish(false);
        setPublishAgain(false);
        setSubmitting(false);
      }, 2000);
    } catch (error) {
      console.error('Error finalizing/publishing audit:', error);
      toast.error("Failed to process audit.");
      setPublish(false);
      setPublishAgain(false);
      setSubmitting(false);
    }
  }

  async function publishFinalAudit(e: any, publishPayload: any) {
    preventDefault(e);
    setSubmitting(true);

    try {
      let response: any = await api.put(`/api/v1/vendor_location_audits/${currentAudit.id}/${VENDOR_AUDIT_STATUS.FINAL_AUDIT_PUBLISHED}`, publishPayload);
      if(response instanceof AxiosError){
        toast.error("Failed to publish final audit. Please try again.");
        setSubmitting(false);
        return;
      }
      setTimeout(async() => {
        toast.success("Final audit published successfully. Generating report...");
        await refetchAudit();
        refetch();
        setPublish(false);
        setPublishAgain(false);
        setSubmitting(false);
      }, 2000);
    } catch (error) {
      console.error('Error publishing final audit:', error);
      toast.error("Failed to publish final audit.");
      setPublish(false);
      setPublishAgain(false);
      setSubmitting(false);
    }
  }

  const buttons: ActionButton[] = [
    // {
    //   label: "Bulk Upload",
    //   name: "bulkUpload",
    //   privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_UPLOAD,
    //   action: () => {
    //     setBulkUpload(true);
    //   },
    // },
    {
      label: "Submit to Auditor",
      name: "submitToAuditor",
      privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_SUBMIT,
      action: () => {
        onSubmitToAuditor();
      },
    },
    {
      label: "Publish",
      name: "publish",
      privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH,
      action: () => publishActivity(null),
    },
    // {
    //   label: "Send Report",
    //   name: "sendReport",
    //   action: () => {
    //     setAction(ACTIONS.SEND_REPORT);
    //   },
    // },
  ];

  const publishAgainButtons: ActionButton[] = [
    {
      label: "Publish and trigger an email",
      name: "publishAndTriggerAnEmail",
      privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH,
      action: () => {
        publishAndTriggerEmail();
      },
    },
    {
      label: "Publish without triggering an email",
      name: "publishWithoutTriggeringAnEmail",
      privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH,
      action: () => publishWithoutTriggeringEmail(),
    }
  ];


  useEffect(() => {
    if(!activities || activities.length === 0) {
      setIsFirstTimePublish(true);
    } else {
      refetchAudit();
    }
  }, [activities])

  async function refetchAudit() {
    if (auditId) {
      try {
        const response = await api.get(`/api/v1/vendor_location_audits/${auditId}`, {
          include: include,
          includes: includes
        });
        if (response && response.data) {
          setCurrentAudit(response.data);
          setIsFirstTimePublish(!(response.data.report_version > 0));
          // setIsFirstTimePublish(!response.data.final_report || [VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(response.data.status));
        }
      } catch (error) {
        console.error('Error refreshing audit:', error);
      }
    }
  }

  function editActivity(activity: any) {
    setActivity(activity);
  }

  function downloadForm(activity: any) {
    setSubmitting(true);
    api
      .get(`/api/v1/act_state_mappings/${activity.act_state_mapping_id}`)
      .then((response) => {
        if (response.data.file_path) {
          download(response.data.file_name, response.data.file_path);
        } else {
          toast.warn("No files available");
        }
      })
      .finally(() => setSubmitting(false));
  }

  const downloadReportButtons: ActionButton[] = [
    {
      label: "Preliminary Report",
      name: "preliminaryReport",
      privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_DOWNLOAD_REPORT,
      action: () => {
        downloadReport(null, 'preliminary');
      },
    },
    {
      label: "Final Report",
      name: "finalReport",
      privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_DOWNLOAD_REPORT,
      action: () => {
        downloadReport(null, 'final');
      },
    },
    {
      label: "Preliminary Report",
      name: "preliminaryReport",
      privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT,
      action: () => {
        downloadReport(null, 'preliminary');
      },
    },
    {
      label: "Final Report",
      name: "finalReport",
      privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT,
      action: () => {
        downloadReport(null, 'final');
      },
    }
  ];

  async function downloadReport(event: any, reportType: 'preliminary' | 'final') {
    preventDefault(event);
    if (currentAudit && currentAudit.id) {
      if(reportType == 'preliminary' && [VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED].includes(currentAudit.status)){
        toast.warn("Preliminary report is not available as Preliminary audit is not yet published.");
        return;
      }
      if(reportType == 'final' && [VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_PENDING, VENDOR_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_EDITING].includes(currentAudit.status)){
        toast.warn("Final report is not available as Final audit is not yet published.");
        return;
      }
      setSubmitting(true);
      try {
        let reportData: any;
        if(currentAudit && (currentAudit.preliminary_report || currentAudit.final_report)){
          reportData = reportType == 'preliminary' ? currentAudit.preliminary_report : currentAudit.final_report;
        } else {
          const response = await api.get(`/api/v1/vendor_location_audits/${currentAudit.id}`, {
            include: include,
            includes: includes
          });
          reportData = reportType == 'preliminary' ? response.data.preliminary_report : response.data.final_report;
        }
        setSelectedReportForDownload(reportData);

        const { s3_region, s3_key, s3_bucket } = reportData || {};
        if (s3_region && s3_key && s3_bucket) {
          auditReportVendor({
            s3_region,
            s3_key,
            s3_bucket
          });
        } else {
          const reportTypeName = reportType.charAt(0).toUpperCase() + reportType.slice(1);
          toast.warn(`${reportTypeName} report is not available`);
        }
      } catch (error) {
        console.error('Error fetching audit:', error);
      }
      setSubmitting(false);
    }
  }

  function onSubmitToAuditor() {
    if(!canSubmitToAuditor(currentAudit, userRole)) {
      toast.error("You cannot submit activities to auditor at this stage.");
    } else {
      setSubmitting(true);
      const _payload = {
        filters: {
          vendor_location_audit_id_eq: auditId
        }
      };
      api
        .get("/api/v1/todo_vendors", _payload)
        .then((response) => {
          if (response && response.data) {
            const _rows = (response.data || {data: {}}).items || [];
            const _applicableRows = _rows.filter((x: any) => ![ACTIVITY_STATUS.AUDITED, ACTIVITY_STATUS.SUBMITTED].includes(x.status));
            const _published = _applicableRows.filter((x: any) => x.published) || [];
            if (_published.length && (_published.length == _rows.length)) {
              setAlertMessage(
                "All the activities are published for the selected month and year. See Audit report for more details."
              );
            } else if (_applicableRows.length) {
              setSelectedRows(_applicableRows);
              setSubmitToAuditor(true);
            } else if([VENDOR_AUDIT_STATUS.FINAL_AUDIT_PENDING].includes(currentAudit.status)) {
                setSelectedRows(_applicableRows);
                setSubmitToAuditor(true);
              } else {
              toast.warn("There are no activities available for submission.");
            }
          }
        })
        .finally(() => setSubmitting(false));
    }
  }

  async function onSubmitToAuditorHandler(e: any) {
    preventDefault(e);
    const todoIds = selectedRows.map((x) => x.id);

    // Use state machine to determine which submit function to call
    const newAuditStatus = getNewAuditStatusAfterSubmit(currentAudit.status);

    if (newAuditStatus !== currentAudit.status) {
      // Call appropriate function based on state machine result
      if (newAuditStatus === VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED) {
        await submitToAuditorPreliminaryAudit(todoIds);
      } else if (newAuditStatus === VENDOR_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED) {
        await submitToAuditorFinalAudit(todoIds);
      }
    }
  }

  async function submitToAuditorPreliminaryAudit(todoIds: any[]) {
    setSubmitting(true);
    const newAuditStatus = VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED;
    try {
      const updatePayload = {
        todo_ids: todoIds,
      };
      await api.put(`/api/v1/vendor_location_audits/${currentAudit.id}/${newAuditStatus}`, updatePayload);
      setTimeout(async () => {
        toast.success("Preliminary audit submitted successfully.");
        await refetchAudit();
        refetch();
        setSubmitToAuditor(false);
        setSubmitting(false);
      }, 2000);
    } catch (error) {
      toast.error("Failed to submit preliminary audit. Please try again.");
      console.error('Error submitting preliminary audit:', error);
      setSubmitToAuditor(false);
      setSubmitting(false);
    }
  }

  async function submitToAuditorFinalAudit(todoIds: any[]) {
    setSubmitting(true);
    const newAuditStatus = VENDOR_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED;
    try {
      const updatePayload = {
        todo_ids: todoIds,
      };
      setTimeout(async () => {
        await api.put(`/api/v1/vendor_location_audits/${currentAudit.id}/${newAuditStatus}`, updatePayload);
        toast.success("Final audit submitted successfully.");
        await refetchAudit();
        refetch();
        setSubmitToAuditor(false);
        setSubmitting(false);
      }, 2000);
    } catch (error) {
      toast.error("Failed to submit final audit. Please try again.");
      console.error('Error submitting final audit:', error);
      setSubmitToAuditor(false);
      setSubmitting(false);
    }
  }


  function onFormStatusChangeHandler(e: any) {
    setCheckedStatuses({
      ...(checkedStatuses || {}),
      [e.target.name]: e.target.checked,
    });
  }

  function search(event: any) {
    const _filters: any = {
      vendor_location_audit_id_eq: auditId
    };
    const keys = Object.keys(event || {});
    if (keys.length > 0) {
      keys.forEach((key) => {
        _filters[key] = event[key];
      });
    }
    setAdvanceSearchFilters(_filters);
  }

  function MonthTmpl({ cell }: any) {
    const row = cell.getData();
    return (
      <>
        {row.month} ({row.year})
      </>
    );
  }
  function DueDateTmpl({ cell }: any) {
    const value = cell.getValue();
    return (
      <span className="text-warn">{dayjs(value).format("DD-MM-YYYY")}</span>
    );
  }

  function bulkFileDownloadthroughZip(event: any) {
    event.preventDefault();

    const selectedStatuses = Object.keys(checkedStatuses).filter((status) => checkedStatuses[status] === true)

    const filters = {
      vendor_location_audit_id_eq: auditId,
      status_in: selectedStatuses
    };

    event.preventDefault();
    const arrayOfData = (data || {}).data || [];
    let filtered = arrayOfData.filter((t: { id: string }) => t.id);
    const activityIds = filtered.map((t: { id: string }) => t.id);
    if (activityIds.length > 0) {
      api.post("/api/v1/todo_vendor_details/bulk_download",{filters, todo_vendor_ids: activityIds},{
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/zip" },
      }).then((response: any) => {
        if (response instanceof AxiosError) {
            const contentType = response.response && response.response.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                const errorJson = (response.response || {}).data || {};
                let error = (errorJson || {}).error|| [ERROR_MESSAGES.DEFAULT];
                toast.warning(error);
            }
        } else {
          const {data} = response || {};
          let respo = (data || { data: {} }).data;
          if(respo.success) {
              const urlMatch = respo.file_url;
              if (urlMatch) {
                  const zipFileUrl = decodeURIComponent(urlMatch);
                  // Directly trigger download from the extracted URL
                  window.location.href = zipFileUrl;
                  toast.success("Zip FIle Downloaded");
              }
          } else {
              toast.warning(respo.error);
          }
        }
      }).catch((error : any) => {
          if (error instanceof AxiosError) {
              const contentType = error.response && error.response.headers['content-type'] || "";
              if (contentType.includes('application/json')) {
                  const errorJson = (error.response || {}).data || {};
                  let errorMessage = (errorJson || {}).error|| [ERROR_MESSAGES.DEFAULT];
                  toast.warning(errorMessage);
              }
          } else {
              console.error("Error downloading the file:", error);
              toast.warning("Failed to download the ZIP files.");
          }
      });
      } else {
        toast.warning("There are no files available.");
      }
  }

  function ActionHeaderTmpl() {
    return (
      <div className={`nav-item dropdown ${styles.tableActions}`}>
        <div
          className="nav-link text-white"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </div>
        <div className="dropdown-menu">
          <a className="dropdown-item" href="/" onClick={handleExport}>
            Export
          </a>
          {/* removed this as api is not implemented */}
          <a
            className="dropdown-item"
            href="/"
            onClick={bulkFileDownloadthroughZip}
          >
            All Files Download
          </a> 

          {selectedRows.length !== 0 && (
            <a
              className="dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                setVendorUpload(true);
              }}
            >
              Bulk Upload
            </a>
          )}
        </div>
      </div>
    );
  }

  function FormStatusTmpl({ cell }: any) {
    const status = cell.getValue();
    const row = cell.getData();
    return (
      <div className="d-flex align-items-center position-relative">
        {!!row.forms_status_remarks && (
          <OverlayTrigger
            overlay={<Tooltip>
              <div dangerouslySetInnerHTML={{ __html: row.forms_status_remarks }}></div>
            </Tooltip>}
            placement="bottom"
            delay={{ show: TOOLTIP_DELAY } as any}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
          </OverlayTrigger>
        )}
        <span className={`status-${status} ellipse`}>
          {STATUS_MAPPING[status] || status}
        </span>
      </div>
    );
  }

  function AuditStatusTmpl({ cell }: any) {
    const status = cell.getValue();
    const row = cell.getData();
    const color = {
      [AUDIT_STATUS.COMPLIANT]: "status-compliant",
      [AUDIT_STATUS.NON_COMPLIANCE]: "status-non-compliance",
      [AUDIT_STATUS.NOT_APPLICABLE]: "status-not-applicable",
    };
    return (
      <div className="d-flex align-items-center position-relative">
        {!!row.audit_remarks && (
          <OverlayTrigger
            overlay={<Tooltip>
              <div dangerouslySetInnerHTML={{ __html: row.audit_remarks }}></div>
            </Tooltip>}
            placement="bottom"
            delay={{ show: TOOLTIP_DELAY } as any}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
          </OverlayTrigger>
        )}
        {status && (
          <span className={`${color[status]} ellipse`}>
            {STATUS_MAPPING[status] || status}
          </span>
        )}
      </div>
    );
  }

  function ActionColumnElements({ cell }: any) {
    const row = cell.getData();
    return (
      <div className="d-flex flex-row align-items-center position-relative">
        <Icon
          className="mx-2"
          type="button"
          name={
            hasUserAccess(USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_UPLOAD) ||
            hasUserAccess(USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_AUDIT)
              ? "pencil"
              : "eye"
          }
          text={
            hasUserAccess(USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES_UPLOAD) ||
            hasUserAccess(USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_AUDIT)
              ? "Edit"
              : "View"
          }
          data={row}
          action={editActivity}
        />
        <Icon
          className="ms-1"
          type="button"
          name="download"
          text="Download"
          data={row}
          action={downloadForm}
        />
      </div>
    );
  }

  function ActivityTypeTmpl({ cell }: any) {
    const value = cell.getValue() || ACTIVITY_TYPE.AUDIT;
    return (
      <div className="d-flex flex-row align-items-center justify-content-center position-relative">
        <Icon name={ACTIVITY_TYPE_ICONS[value]} text={value} />
      </div>
    );
  }

  const columns = [
    {
      title: "",
      field: "auditted",
      width: 40,
      formatter: reactFormatter(<ActivityTypeTmpl />),
    },
    {
      title: "Month & Year",
      field: "month",
      width: 140,
      formatter: reactFormatter(<MonthTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      headerClick: (e: any, col: any) => {
        preventDefault(e);
      },
    },
    {
      title: "Act",
      field: "act.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },

    {
      title: "Rule",
      field: "rule.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Activity",
      field: "activity.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 2,
    },
    {
      title: "Activity Type",
      field: "activity.activity_type",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Associate Company",
      field: "associate_company.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 1,
    },
    {
      title: "Location Name",
      field: "location.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 1,
    },
    {
      title: "Audit Due Date",
      field: "due_date",
      width: 120,
      formatter: reactFormatter(<DueDateTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Compliance Status",
      field: "audit_status",
      maxWidth: 160,
      formatter: reactFormatter(<AuditStatusTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Evidence Status",
      field: "status",
      maxWidth: 160,
      formatter: reactFormatter(<FormStatusTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Actions",
      hozAlign: "center",
      width: 100,
      headerSort: false,
      formatter: reactFormatter(<ActionColumnElements />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
  ];

  const [tableConfig] = useState({
    paginationMode: "remote",
    ajaxRequestFunc,
    columns,
    rowHeight: "auto",
    selectable: getUserRole() === "Vendor User" ? true : false,
    paginate: true,
    initialSort: ["month desc"],
    rowFormatter,
  });

  function rowFormatter(row: any) {
    const data = row.getData();
    const element = row.getElement();
    if (data.published) {
      element.classList.add("activity-published");
    }
  }

  function formatApiResponse(params: any, list: any, totalRecords: number) {
    const { page, per } = params || {};
    const tdata = {
      data: list,
      total: totalRecords,
      last_page: Math.ceil(totalRecords / (per || 1)) || 1,
      page: page || 1,
    };
    return tdata;
  }

  function hasFilters(ref: any, field = "company_id_eq") {
    const _filters: any =
      (ref
        ? ref.current
        : ({ ...(payloadRef.current || {}) } as any)["filters"]) || {};
    return _filters[field];
  }

  function ajaxRequestFunc(url: any, config: any, params: any) {
    const { field, dir } = (params.sort || [])[0] || {};
    const _params = {
      per: params.size,
      page: params.page,
      sorts: [`${SortFields[field] || field || "month"} ${dir || "desc"}`],
      include: ['act', 'rule', 'activity', 'location', 'associate_company', 'company'],
      includes: ['act', 'rule', 'activity', 'location', 'company', 'associate_company']
    };
    setParams(_params);
    setPayload({
      ...DEFAULT_PAYLOAD,
      ..._params,
      filters: {
        ...(afRef.current || {}),
        ...(sfRef.current || {}),
      },
    });
    return Promise.resolve(formatApiResponse(params, activities, total));
  }

  function handlePageNav(_pagination: any) {
    const _params = { ...params, ..._pagination };
    setParams({ ..._params });
    setPayload({ ...(payload as any), ..._params });
  }

  function getAdvanceSearchPayload() {
    return {...(afRef.current || {})};
  }

  function handleVendorBulkUploadClose(refresh = false) {
    if (refresh) {
      refetch();
    }
    setVendorUpload(false);
  }
  function handleBulkUploadClose(refresh = false) {
    if (refresh) {
      refetch();
    }
    setBulkUpload(false);
  }

  function handleExport(event: any) {
    event.preventDefault();
    if (total < 1) {
      toast.warn("There are no records available for this filter criteria.");
      return;
    }
    const _payload = {
      ...DEFAULT_PAYLOAD,
      sorts: ['month desc'],
      ...params,
      filters: {
        ...(afRef.current || {}),
        ...(sfRef.current || {})
      },
      page: 1,
      per: total
    };
    exportTodos(_payload);
  }

  useEffect(() => {
    if (advaceSearchFilters && advaceSearchFilters.vendor_location_audit_id_eq) {
      const _params = { ...params, page: 1 };
      setParams({ ..._params });
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        sorts: ['month desc'],
        ..._params,
        filters: {
          ...(advaceSearchFilters || {}),
          ...(sfRef.current || {})
        },
      });
    }
  }, [advaceSearchFilters]);

  useEffect(() => {
    if (advaceSearchFilters && advaceSearchFilters.vendor_location_audit_id_eq) {
      const _params = { ...params, page: 1 };
      setParams({ ..._params });
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        sorts: ['month desc'],
        ..._params,
        filters: {
          ...(afRef.current || {}),
          ...(statusFilters || {})
        },
      });
    }
  }, [statusFilters]);

  useEffect(() => {
    if (checkedStatuses) {
      const keys = Object.keys(checkedStatuses);
      const result = keys.filter((key) => !!checkedStatuses[key]);
      const _result: any = {};
      if (result.length > 0) {
        _result['status_in'] = result
      }
      setStatusFilters(_result);
    }
  }, [checkedStatuses]);

  useEffect(() => {
    if (!isFetching && payload) {
      setSelectedRows([]);
      setData(formatApiResponse(params, activities, total));
    }
  }, [isFetching]);

  function backToAuditList(event: any) {
    event.preventDefault();
    navigate('/vendor-audits', {
      state: {
        ...(state || {})
      }
    });
  }

  async function editAudit(event: any) {
    preventDefault(event);
    setSubmitting(true);
    await api.put(`/api/v1/vendor_location_audits/${currentAudit.id}/${VENDOR_AUDIT_STATUS.FINAL_AUDIT_EDITING}`);
    setTimeout(async() => {
      toast.success("Audit moved to editing state.");
      await refetchAudit();
      refetch();
      setSubmitting(false);
    }, 2000);
  }

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex  p-2 align-items-center pageHeading shadow">
          <h4 className="mb-0">Vendor Audits</h4>
          <div className="d-flex align-items-end h-100">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 d-flex justify-content-end">
                <li className="breadcrumb-item">Home</li>
                {fromDashboard && (
                  <li className="breadcrumb-item fw-bold">
                    <Link href="/dashboard">Dashboard</Link>
                  </li>
                )}
                <li className="breadcrumb-item  fw-bold active"><Link href="/vendor-audits" onClick={backToAuditList}>Audit Compliances</Link></li>
                <li className="breadcrumb-item  fw-bold active">
                  Audit Details
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <form className="p-0 mx-3 my-2">
          <div className="" style={{ fontSize: '20px', fontWeight: "600" }}>
              <span style={{cursor: 'pointer'}} onClick={backToAuditList}>
                <FontAwesomeIcon icon={faArrowLeft} />
                &nbsp;
                Activity List
              </span>
              <span>
                &nbsp;-&nbsp;
                {(currentAudit.vendor_registration || {}).vendor_name || ''} - {(currentAudit.location || {}).name || ''}
              </span>
              <span>
                &nbsp;
                <IconButton onClick={() => setShowAuditDetails(true)} >
                  <IoMdInformationCircleOutline />
                </IconButton>
              </span>
              <span className={`${AUDIT_STATUS_COLOR_CODES[currentAudit.status as keyof typeof AUDIT_STATUS_COLOR_CODES] || 'text-dark-gray'}`} style={{ fontSize: '16px', fontWeight: "500" }}>
                &nbsp;
                {AUDIT_STATUS_LABELS[currentAudit.status as keyof typeof AUDIT_STATUS_LABELS] || currentAudit.status}
              </span>
          </div>
          <div className="card shadow border-0 p-2 mt-2 mb-3">
            <div className="d-flex flex-row auditFilters filters">
              <AuditLocationFilters onChange={search} />
            </div>
          </div>
          <div className="card shadow border-0 p-2 mb-2">
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center status-btn-group">
                <label className="filter-label">
                  <small>Evidence Status</small>
                </label>
                {statusBtns.map((btn) => {
                  return (
                    <div className="mx-2" key={btn.name}>
                      <input
                        name={btn.name}
                        type="checkbox"
                        className="btn-check"
                        id={btn.name}
                        autoComplete="off"
                        onChange={onFormStatusChangeHandler}
                        checked={checkedStatuses[btn.name]}
                      />
                      <label
                        className={`btn bg-status-${btn.name}`}
                        htmlFor={btn.name}
                      >
                        {btn.label}
                      </label>
                    </div>
                  );
                })}
              </div>

              <div className="d-flex">
                {hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH) && currentAudit && [VENDOR_AUDIT_STATUS.FINAL_AUDIT_PUBLISHED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_UPLOADED, VENDOR_AUDIT_STATUS.FINAL_AUDIT_REPORT_UPLOADING].includes(currentAudit.status) && <Button variant={'primary'} key={'donloadMonthWiseReport'}
                    className="px-3 mx-3 d-flex flex-row align-items-center gap-2"
                    onClick={(e: any) => setEnableEditAlert(true)}>
                    <span>Edit</span>
                    <Icon name={'pencil'} />
                </Button>}
                <div className="px-3 mx-3 d-flex flex-row align-items-center gap-2">
                  <TableActions buttons={downloadReportButtons} btnLabel="Download Report" />
                </div>
                {hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES_SUBMIT) && <TableActions buttons={buttons} />}
                {hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH) && isFirstTimePublish && <TableActions buttons={buttons} />}
                {hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH) && !isFirstTimePublish && activities && activities.length > 0 && <TableActions buttons={publishAgainButtons} btnLabel="Publish" />}
              </div>
            </div>
          </div>
        </form>
        <div className="position-relative">
          <ActionHeaderTmpl />
          <Table
            data={data}
            options={tableConfig}
            isLoading={isFetching}
            onSelectionChange={setSelectedRows}
            onPageNav={handlePageNav}
          />
        </div>
      </div>

      {vendorUpload && (
        <VendorBulkUploadModal
          onClose={handleVendorBulkUploadClose}
          selectedItems={selectedRows}
          isVendor={true}
        />
      )}
      {bulkUpload && (
        <BulkUploadModal onClose={handleBulkUploadClose} onSubmit={refetch} />
      )}
      {submitToAuditor && (
        <SubmitToAuditorModal
          onClose={() => setSubmitToAuditor(false)}
          onSubmit={onSubmitToAuditorHandler}
          selectedRows={selectedRows}
          auditStatus={currentAudit.status}
        />
      )}
      {showAuditDetails && (
        <AuditDetailsModal
          onClose={() => setShowAuditDetails(false)}
          audit={currentAudit}
          auditType="vendor_location"
        />
      )}
      {!!activity && selectedRows.length >= 0 && (
        <>
          {hasUserAccess(USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES_AUDIT) ? (
            <AuditorVendorActivityModal
              activity={activity}
              auditStatus={(currentAudit || {}).status}
              onClose={() => setActivity(null)}
              onSubmit={() => {refetchAudit(); refetch()}}
              selectedItems={selectedRows}
            />
          ) : (
            <EditActivityModal
              activity={activity}
              auditStatus={(currentAudit || {}).status}
              onClose={() => setActivity(null)}
              onSubmit={refetch}
              selectedItems={selectedRows}
            />
          )}
        </>
      )}

      {!!alertMessage && (
        <AlertModal
          message={alertMessage}
          onClose={(e: any) => {
            preventDefault(e);
            setAlertMessage(null);
          }}
        />
      )}
      {publish && (
        <PublishModal
          onClose={() => setPublish(false)}
          onSubmit={onPublish}
          selectedRows={selectedRows}
          auditType="todoVendor"
          audit={currentAudit}
          auditPhase={[VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, VENDOR_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED].includes(currentAudit.status) ? "preliminary" : "final"}
        />
      )}
      {publishAgain && (
        <PublishAgainModal
          onClose={() => setPublishAgain(false)}
          onSubmit={onPublishAgain}
          selectedRows={selectedRows}
          isEmail={sendEmailOnPublishAgain}
          audit={currentAudit}
        />
      )}
      {action === ACTIONS.SEND_REPORT && (
        <SendEmailModal onCancel={() => setAction(ACTIONS.NONE)} />
      )}
      {enableEditAlert && <ConfirmModal
        message="Are you sure you want to <b>Revise and update</b> this audit? This audit is already published."
        onClose={(e: any) => {
          preventDefault(e);
          setEnableEditAlert(false);
        }}
        onSubmit={editAudit}
      />}
      {(submitting || exporting || exportingTodos) && <PageLoader />}
    </>
  );
}

export default VendorLocationActivitiesManagement;
